export const utmOfferIncentiveBannerSupportedPaths = ['/men/welcomeback', '/women/welcomeback'];